import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=1fcf15a8&scoped=true&"
import script from "./Launcher.vue?vue&type=script&lang=ts&"
export * from "./Launcher.vue?vue&type=script&lang=ts&"
import style0 from "./Launcher.vue?vue&type=style&index=0&id=1fcf15a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf15a8",
  null
  
)

export default component.exports